import { Accordion, AccordionSummary, AccordionDetails, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

type Props = {
  title: string;
  description?: React.ReactNode;
  defaultExpanded?: boolean;
  children: React.ReactNode;
};

export const SettingsAccordion = ({
  title,
  description,
  defaultExpanded = false,
  children
}: Props) => {
  return (
    <Accordion defaultExpanded={defaultExpanded}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          minHeight: 48,
          borderBottom: "1px solid transparent",
          "&.Mui-expanded": {
            minHeight: 48,
            borderBottomColor: "divider"
          },
          "& .MuiAccordionSummary-content, & .MuiAccordionSummary-content.Mui-expanded": {
            margin: "12px 0"
          }
        }}
      >
        <Typography fontWeight={600}>{title}</Typography>

        {description}
      </AccordionSummary>

      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
};
